import React from 'react';
import { connect } from 'react-redux';
import { Field, FieldArray, reduxForm } from 'redux-form';
import { useTranslation } from 'react-i18next';

import Typography from '@material-ui/core/Typography';

import { PLATFORMS } from 'pages/create-activity/constants';

import { deleteIntegrations } from 'actions/activityAndAccommodation';

import {
  DropDown,
  ExpansionPanelWrapper,
  FormActionButtons,
  Input
} from 'components';

import validate from './validate';

import { useStyles } from './styles';

const initialValues = {
  integrations: []
};

const Integration = ({
  handleSubmit,
  deleteIntegrations,
  isAccommodation,
  setSubmitButton
}) => {
  const classes = useStyles();
  const [t] = useTranslation();

  const onAddHandler = (fields, id) => {
    fields.push({
      id: id,
      platform: '',
      titleOnPlatform: ''
    });
  };

  const onDeleteHandler = item => {
    if (item.isCreated) deleteIntegrations(item.id);
  };

  return (
    <div className={classes.wrapper}>
      <Typography variant="h1" className={classes.title}>
        {t('Integration')}
      </Typography>
      <form onSubmit={handleSubmit}>
        <FieldArray
          name="integrations"
          component={ExpansionPanelWrapper}
          isAddDeleteActions={true}
          add={onAddHandler}
          remove={onDeleteHandler}
          getTitle={item => item.platform}
          tabName="integration"
          tabNameAll="all integrations"
          children={field => (
            <div className={classes.row}>
              <Field
                name={`${field}.platform`}
                className={classes.input}
                list={PLATFORMS}
                label="Platform *"
                component={DropDown}
              />
              <Field
                name={`${field}.titleOnPlatform`}
                className={classes.input}
                inputProps={{ maxLength: 255 }}
                placeholder={
                  isAccommodation ? 'Accommodation url' : 'Activity url'
                }
                label={
                  isAccommodation
                    ? 'Accommodation on the platform *'
                    : 'Activity on the platform *'
                }
                component={Input}
              />
            </div>
          )}
        />
        <FormActionButtons
          cancelPath="/accommodations-and-activities"
          actionLabel="Save"
          integration
          setSubmitButton={setSubmitButton}
        />
      </form>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  deleteIntegrations: id => dispatch(deleteIntegrations(id))
});

export default reduxForm({
  form: 'integrationForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
  touchOnBlur: false,
  validate,
  initialValues
})(connect(null, mapDispatchToProps)(Integration));
